import { connect } from 'react-redux'
import MaintenanceAppendCardsComponent from '../components/MaintenanceAppendCardsComponent.jsx';
import {
    clean,
    forwardToFindFixableMCards,
	forwardToSortFixableMaintenanceCards,
	forwardToAssignAppendTarget,
	// forwardToFindFixableMCases,
	// forwardToAssignModifyingTarget,
	forwardToFindPhotosByCard,
	changePhotoListPreviousPage
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceFixingReducer', 'request']),
	response: state.getIn(['maintenanceFixingReducer', 'response']),
	options: state.getIn(['maintenanceFixingReducer', 'options']),
	
})

const mapDispatchToProps = (dispatch) => ({
    
    findFixableMCards: (casePk) => {
        dispatch(forwardToFindFixableMCards(casePk));
        clean(dispatch);
    },

	sortCards:( cards, order) =>{
		dispatch(forwardToSortFixableMaintenanceCards(cards, order));
        clean(dispatch);
	},

	assignAppendTarget: (card, appendType) =>{
		dispatch(forwardToAssignAppendTarget(card, appendType));
        clean(dispatch);
	},

	// findFixableMCases: () => {
	// 	dispatch(forwardToFindFixableMCases());
	// },
	// assignModifyingTarget: (mcase) => {
	// 	dispatch(forwardToAssignModifyingTarget(mcase));
	// },

	findPhotos: (cardId) => {
		dispatch(forwardToFindPhotosByCard(cardId));
	},
	changePhotoListPreviousPage: (previousPage) => {
		dispatch(changePhotoListPreviousPage(previousPage));
	}
})

const MaintenanceAppendCardsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAppendCardsComponent)

export default MaintenanceAppendCardsContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAppendCardsContainer.jsx